import {environment} from "../../../env.ts";

const TEST_SIZE = 3;

/**
 * The table has performance issues when page size is too big
 * Adjust this value to a lower number in case of performance issues
 */
export const DEFAULT_PAGE_SIZE = environment.isTest ? TEST_SIZE : 25;
export const DEFAULT_PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 50, 100] as number[];
